import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpHandlerFn } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { SupabaseService } from './supabase.service';

@Injectable({providedIn : 'root'})
export class AuthHttpInterceptor implements HttpInterceptor {

  supabaseService = inject(SupabaseService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403 || (error.status === 400 && req.url.includes('/auth/v1/token'))) {
          // Handle 403 Forbidden error
          console.error('Unauthorized access.');
          this.supabaseService.cleanupSession()
        }
        throw error;
      })
    );
  }
}
